export function getOrderParam(orderArray) {
    const orderParam = orderArray?.map((o) => o.fieldName + " " + o.orderCriteria)
    return orderParam
}

